// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.
import React, { useState } from "react";
import {
  data,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import { OutletContextType } from "../../types/GlobalType";
import { LightModeOutlined } from "@mui/icons-material";
import moment from "moment";
import { capitalizeFirstLetter } from "../../_services/utils";
import { StudentType } from "../../_api/controllers/student.controller";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  PonctualiteType,
  studentAttendanceController,
} from "../../_api/controllers/attendance.controller.ts";
import toast from "react-hot-toast";
import {
  montantController,
  motifPaiementController,
  schoolYearController,
} from "../../_api/controllers/scolarite.controller.ts";
import { paymentController } from "../../_api/controllers/payment.controller.ts";
import { useAuth } from "../../_api/auth.js";
const SingleStudent: React.FC = () => {
  // État pour les onglets et le modal
  const [activeTab, setActiveTab] = useState("informations");
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isAbsenceModalOpen, setIsAbsenceModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [selectedStatusAttendance, setSelectedStatusAttendance] =
    useState<any>("Tous les statuts");
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
  const toggleStatusDropdown = () => {
    setIsStatusDropdownOpen(!isStatusDropdownOpen);
  };

  const [paymentForm, setPaymentForm] = useState<{
    date: string;
    amount: any;
    type: any;
    method: string;
    status: any;
    isEditing: boolean;
    editingId?: any;
  }>({
    date: "",
    amount: "",
    type: 1,
    method: "Carte",
    status: 1,
    isEditing: false,
    editingId: null,
  });

  const [currentAttendanceId, SetCurrentAttendanceId] = useState<any>(null);
  const [currentAttendanceCoteId, SetCurrentAttendanceCoteId] =
    useState<any>(null);
  const [currentPaiementId, setCurrentPaiementId] = useState<any>(null);
  const [absenceForm, setAbsenceForm] = useState<{
    date: string;
    reason: string;
    status?: any;
    justified: boolean;
    isEditing: boolean;
    editingId: any;
  }>({
    date: "",
    reason: "",
    status: null,
    justified: false,
    isEditing: false,
    editingId: null,
  });
  const [contactForm, setContactForm] = useState<{
    recipients: string[];
    subject: string;
    message: string;
    attachments: any;
    parentEmail: string;
  }>({
    recipients: [],
    subject: "",
    message: "",
    attachments: null,
    parentEmail: "",
  });
  const [showNotification, setShowNotification] = useState(false);
  const [isReceiptModalOpen, setIsReceiptModalOpen] = useState(false);
  // const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  // const [selectedHistoryFilter, setSelectedHistoryFilter] = useState("all");
  const [isAnnulerPaymentModalOpen, setIsAnnulerPaymentModalOpen] =
    useState(false);
  // const [studentStatus, setStudentStatus] = useState("Actif");
  const [notificationMessage, setNotificationMessage] = useState("");

  const [receiptData, setReceiptData] = useState<{
    id: string;
    date: string;
    amount: number;
    type: string;
    method: string;
    status: any;
    student: string;
    class: string;
  } | null>(null);

  const handleContactSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsContactModalOpen(false);
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 3000);
    setContactForm({
      recipients: [],
      subject: "",
      message: "",
      attachments: null,
      parentEmail: "",
    });
  };
  const handleContactInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    if (name === "recipients") {
      const select = e.target as HTMLSelectElement;
      const selectedOptions = Array.from(select.selectedOptions).map(
        (option) => option.value
      );
      setContactForm((prev) => ({
        ...prev,
        [name]: selectedOptions,
      }));
    } else {
      setContactForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const queryClient = useQueryClient();

  //Update attendance
  const mutationUpdateAttendance = useMutation({
    mutationFn: () =>
      studentAttendanceController.update(currentAttendanceId, {
        justification: absenceForm.reason,
        cote_eleve_id: currentAttendanceCoteId,
      }),
    onSuccess: (data) => {
      // console.log(data);
      toast.success("Ponctualité modifiée avec succès!", {
        duration: 4000,
        position: "bottom-right",
        style: { background: "green", color: "#fff" },
      });

      setIsAbsenceModalOpen(false);
      queryClient.invalidateQueries({ queryKey: ["studentAttendance"] });
    },

    onError: (err) => {
      toast.error("Une erreur est survenue, réessayer.", {
        duration: 4000,
        position: "bottom-right",
        style: {
          background: "red",
          color: "#fff",
          padding: "10px",
          fontSize: "14px",
          borderRadius: "5px",
        },
      });
    },
  });

  const mutationAnnulerPayment = useMutation({
    mutationFn: () => paymentController.desactivate(currentPaiementId),
    onSuccess: (data) => {
      console.log("desactivate Mutation", data);
      setIsAnnulerPaymentModalOpen(false);
      setShowNotification(true);
      setNotificationMessage("Annulation effectuée avec succès!");
      setTimeout(() => {
        setShowNotification(false);
        setNotificationMessage("");
      }, 3000);
      setCurrentPaiementId(null);
      queryClient.invalidateQueries({ queryKey: ["payments"] });
    },

    onError: (err) => {
      console.log(err);
      toast.error("Une erreur est survenue, réessayer.", {
        duration: 4000,
        position: "bottom-right",
        style: {
          background: "red",
          color: "#fff",
          padding: "10px",
          fontSize: "14px",
          borderRadius: "5px",
        },
      });
    },
  });

  //get User context && from localstorage
  const { user } = useAuth();
  //update payment & save new payement
  const mutationCreatePayment = useMutation({
    mutationFn: () =>
      paymentController.create({
        montant: paymentForm.amount,
        jour: moment().format("YYYY-MM-DD HH:mm:ss"),
        motif_paiement_id: paymentForm.type,
        eleve_id: dataStudent.eleve_id,
        personnel_id: user.personnel_id, //Id du prefet
        annee_scolaire_id: activeSchoolYear?.data[0].id,
        operation_id: `PAY-${moment().year()}-${moment().month()}-${moment().format(
          "DDHHMMSS"
        )}`,
        uid_terminal: "878da08c4808b62c",
      }),
    onSuccess: (data) => {
      console.log("create Mutation", data);

      // toast.success("Paiement effectué avec succès!", {
      //   duration: 4000,
      //   position: "bottom-right",
      //   style: { background: "green", color: "#fff" },
      // });
      setIsPaymentModalOpen(false);
      setShowNotification(true);
      setNotificationMessage("Paiement effectué avec succès!");
      setTimeout(() => {
        setShowNotification(false);
        setNotificationMessage("");
      }, 3000);
      setPaymentForm({
        date: "",
        amount: "",
        type: "",
        method: "Espèce",
        status: 1,
        isEditing: false,
        editingId: null,
      });
      queryClient.invalidateQueries({ queryKey: ["payments"] });
    },

    onError: (err) => {
      toast.error("Une erreur est survenue, réessayer.", {
        duration: 4000,
        position: "bottom-right",
        style: {
          background: "red",
          color: "#fff",
          padding: "10px",
          fontSize: "14px",
          borderRadius: "5px",
        },
      });
    },
  });

  const mutationUpdatePayment = useMutation({
    mutationFn: () =>
      paymentController.update(currentPaiementId, {
        montant: paymentForm.amount,
        jour: moment().format("YYYY-MM-DD HH:mm:ss"),
        motif_paiement_id: paymentForm.type,
        eleve_id: dataStudent.eleve_id,
        personnel_id: user.personnel_id, //Id du prefet
        annee_scolaire_id: activeSchoolYear?.data[0].id,
        operation_id: `INV-${moment().year()}-00${moment().format(
          "DDMMYYYYHHMMSS"
        )}`,
        uid_terminal: "878da08c4808b62c",
      }),
    onSuccess: (data) => {
      console.log("Update Mutation", data);
      setIsPaymentModalOpen(false);
      setShowNotification(true);
      setNotificationMessage("Paiement modifié avec succès!");
      setTimeout(() => {
        setShowNotification(false);
        setNotificationMessage("");
      }, 3000);
      setPaymentForm({
        date: "",
        amount: "",
        type: "",
        method: "Espèce",
        status: 1,
        isEditing: false,
        editingId: null,
      });
      queryClient.invalidateQueries({ queryKey: ["payments"] });
    },

    onError: (err) => {
      toast.error("Une erreur est survenue, réessayer.", {
        duration: 4000,
        position: "bottom-right",
        style: {
          background: "red",
          color: "#fff",
          padding: "10px",
          fontSize: "14px",
          borderRadius: "5px",
        },
      });
    },
  });

  const handleUpdateAttendance = () => {
    mutationUpdateAttendance.mutate();
  };

  const handleSubmitPayement = () => {
    if (paymentForm.isEditing) {
      mutationUpdatePayment.mutate();
    } else if (!paymentForm.isEditing) {
      mutationCreatePayment.mutate();
    }
  };

  const handleAnnulerPayement = () => {
    mutationAnnulerPayment.mutate();
  };
  // fetch students attendance
  const dataStudent = useLocation().state as StudentType;

  console.log(dataStudent);
  //fetch attendance of the current month
  const date = moment().format("YYYY-MM-DD");
  const { data: studentAttendance } = useQuery({
    queryKey: ["studentAttendance"],
    queryFn: () => studentAttendanceController.getAllByMonth(date),
    select: (data) =>
      data.filter(
        (attendance: PonctualiteType) =>
          attendance.eleve_id === dataStudent.eleve_id
      ),
  });

  // fetch Active schoolYear
  const { data: activeSchoolYear } = useQuery({
    queryKey: ["ActiveSchoolYear"],
    queryFn: schoolYearController.getActive,
  });

  //fetch paiement of current student of cactive school year
  const { data: paiementData } = useQuery({
    queryKey: ["payments"],
    queryFn: paymentController.getAll,
  });

  const paiementDataArr = paiementData ? paiementData.data : [];

  const filteredPaiementsForStudent = paiementDataArr.filter((item) => {
    const id1 = dataStudent.eleve_id ? dataStudent.eleve_id : null;
    const id2 = item.eleve_id ? item.eleve_id : null;
    const matchFilter =
      item.annee_scolaire_id === activeSchoolYear?.data[0].id && id1 === id2;
    return matchFilter;
  });
  // const studentPaiements = paiementData ? paiementData : [];

  // fetch motif Paiement
  const { data: motifPaiementData } = useQuery({
    queryKey: ["motifPaiement"],
    queryFn: motifPaiementController.getAll,
  });

  let motifPaiementArr = motifPaiementData ? motifPaiementData.data : [];

  // fetch Montant frais scolaire
  const { data: montantPerClasse } = useQuery({
    queryKey: ["montantPerClasse"],
    queryFn: montantController.getAll,
    //we select the current montant of current classe of current active school year
    select: (data) =>
      data.data.filter(
        (item) =>
          item.annee_scolaire_id === activeSchoolYear?.data[0].id &&
          item.classe_id === dataStudent.classeId
      ),
  });

  const montantPerClasseArr = montantPerClasse ? montantPerClasse : [];

  const getPaymentAmount = () => {
    const annualTotal = montantPerClasseArr[0]
      ? montantPerClasseArr[0].montant
      : 0;

    //on fait la sommation des paiement avec status === 1
    const paiedTotal = filteredPaiementsForStudent
      .filter((item) => item.status === 1)
      .reduce((sum, paiement) => sum + paiement.montant, 0);
    const balanceTotal = annualTotal - paiedTotal;

    const percentage =
      annualTotal === 0 ? 0 : ((paiedTotal * 100) / annualTotal).toFixed(2);

    return {
      total: annualTotal,
      balance: balanceTotal,
      paid: paiedTotal,
      percentage,
    };
  };

  // console.log(getPaymentAmount().balance);
  // console.log(getPaymentAmount().paid);
  // console.log(getPaymentAmount().total);
  // console.log(paiementData);

  // Manage stats cards data
  const presenceArr =
    studentAttendance?.filter(
      (entry: PonctualiteType) => entry.cote_eleve_id === 1
    ) ?? [];
  const retardArr =
    studentAttendance?.filter(
      (entry: PonctualiteType) => entry.cote_eleve_id === 2
    ) ?? [];
  const absenceArr =
    studentAttendance?.filter(
      (entry: PonctualiteType) => entry.cote_eleve_id === 3
    ) ?? [];

  const retardAbsenceArr = [...retardArr, ...absenceArr];

  const presenceRate =
    presenceArr?.length &&
    retardAbsenceArr?.length &&
    presenceArr?.length + retardAbsenceArr?.length > 0
      ? (
          (presenceArr.length /
            (presenceArr.length + retardAbsenceArr.length)) *
          100
        ).toFixed(1)
      : 0;

  // Filtrer les élèves selon la recherche et les filtres
  const filteredAttendanceList = retardAbsenceArr.filter((attendance) => {
    const matchesStatus =
      selectedStatusAttendance === "Tous les statuts" ||
      attendance.cote_eleve_id == selectedStatusAttendance;
    return matchesStatus;
  });

  // État pour le mode sombre
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  // Fonction pour basculer le mode sombre
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1); // This goes back to the previous page
  };
  return (
    <div className="ml-60 w-full">
      {/* Header */}
      <header
        className={`fixed top-0 left-60 right-0 z-50 py-4 px-6 flex items-center justify-between border-b border-solid ${
          isDarkMode
            ? "border-gray-700 bg-[#0D1117]"
            : "border-gray-200 bg-white"
        }`}
      >
        <div className="flex items-center">
          <button
            onClick={goBack}
            className={`flex items-center px-3 py-2 rounded-md ${
              isDarkMode
                ? "bg-[#161B22] hover:bg-gray-700"
                : "bg-gray-100 hover:bg-gray-200"
            } !rounded-button whitespace-nowrap cursor-pointer`}
          >
            <i className="fas fa-arrow-left mr-2"></i>
            <span>Retour à la liste</span>
          </button>
          <div className="ml-4">
            <span className="text-sm text-gray-500"></span>
          </div>
        </div>
        <div className="flex items-center space-x-4">
          <button
            onClick={toggleDarkMode}
            className="p-2 rounded-full !rounded-button cursor-pointer whitespace-nowrap"
          >
            {isDarkMode ? (
              <LightModeOutlined className="text-yellow-400" />
            ) : (
              <i className="fas fa-moon"></i>
            )}
          </button>
          <button className="p-2 rounded-full !rounded-button cursor-pointer whitespace-nowrap">
            <i className="fas fa-bell"></i>
          </button>
          <button
            className={`w-8 h-8 rounded-full flex items-center justify-center !rounded-button cursor-pointer whitespace-nowrap ${
              isDarkMode ? "bg-gray-700" : "bg-gray-300"
            }`}
          >
            <span>A</span>
          </button>
        </div>
      </header>
      {/* Student Profile Header */}
      <div
        className={`px-6 py-6 border-b mt-24 ${
          isDarkMode ? "border-gray-700" : "border-gray-200"
        }`}
      >
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <div
              className={`w-16 h-16 rounded-full flex items-center justify-center ${
                isDarkMode ? "bg-blue-600" : "bg-blue-500"
              } text-white text-2xl font-bold`}
            >
              {dataStudent?.nom
                .split(" ")
                .map((n) => n[0])
                .join("")}
            </div>
            <div className="ml-4">
              <h1 className="text-2xl font-bold">
                {" "}
                {dataStudent?.nom} {dataStudent?.postnom}{" "}
                {capitalizeFirstLetter(dataStudent?.prenom)}
              </h1>
              <div className="flex items-center mt-1">
                <span
                  className={`px-2 py-1 text-xs font-semibold rounded-full ${
                    dataStudent?.status
                      ? "bg-green-100 text-green-800"
                      : "bg-red-100 text-red-800"
                  } mr-2`}
                >
                  {dataStudent?.status ? "Active" : "Inactive"}
                </span>
                <span
                  className={`px-2 py-1 text-xs font-semibold rounded-full ${
                    isDarkMode ? "bg-gray-700" : "bg-gray-200"
                  }`}
                >
                  {dataStudent?.classeDesignation
                    ? dataStudent?.classeDesignation
                    : "----------"}
                </span>
              </div>
            </div>
          </div>
          <div className="flex space-x-3">
            {/* <button
              className={`px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap`}
            >
              <i className="fas fa-print mr-2"></i>
              <span>Imprimer</span>
            </button> */}

            <button
              id="contactBtn"
              onClick={() => setIsContactModalOpen(true)}
              className={`px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-blue-600 hover:bg-blue-700"
                  : "bg-blue-500 hover:bg-blue-600"
              } text-white !rounded-button whitespace-nowrap`}
            >
              <i className="fas fa-envelope mr-2"></i>
              <span>Contacter</span>
            </button>
            {/* ?essage Contact Modal */}
            {isContactModalOpen && (
              <div className="fixed inset-0 z-50 flex items-center justify-center">
                <div
                  className="absolute inset-0 bg-black bg-opacity-50"
                  onClick={() => setIsContactModalOpen(false)}
                ></div>
                <div
                  className={`relative w-full max-w-lg p-6 rounded-lg shadow-xl ${
                    isDarkMode ? "bg-[#161B22]" : "bg-white"
                  }`}
                >
                  <h3 className="text-xl font-semibold mb-4">
                    Envoyer un message
                  </h3>
                  <form onSubmit={handleContactSubmit}>
                    <div className="mb-4">
                      <label
                        className={`block text-sm font-medium mb-1 ${
                          isDarkMode ? "text-gray-300" : "text-gray-700"
                        }`}
                      >
                        Destinataires
                      </label>
                      <input
                        type="text"
                        name="recipients"
                        value={contactForm.parentEmail}
                        onChange={handleContactInputChange}
                        className={`w-full px-3 py-2 rounded-md border ${
                          isDarkMode
                            ? "bg-[#0D1117] border-gray-700 text-white"
                            : "bg-white border-gray-300"
                        } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        required
                      />
                    </div>
                    <div className="mb-4">
                      <label
                        className={`block text-sm font-medium mb-1 ${
                          isDarkMode ? "text-gray-300" : "text-gray-700"
                        }`}
                      >
                        Objet
                      </label>
                      <input
                        type="text"
                        name="subject"
                        value={contactForm.subject}
                        onChange={handleContactInputChange}
                        className={`w-full px-3 py-2 rounded-md border ${
                          isDarkMode
                            ? "bg-[#0D1117] border-gray-700 text-white"
                            : "bg-white border-gray-300"
                        } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        required
                      />
                    </div>
                    <div className="mb-4">
                      <label
                        className={`block text-sm font-medium mb-1 ${
                          isDarkMode ? "text-gray-300" : "text-gray-700"
                        }`}
                      >
                        Message
                      </label>
                      <textarea
                        name="message"
                        value={contactForm.message}
                        onChange={handleContactInputChange}
                        rows={5}
                        className={`w-full px-3 py-2 rounded-md border ${
                          isDarkMode
                            ? "bg-[#0D1117] border-gray-700 text-white"
                            : "bg-white border-gray-300"
                        } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        required
                      ></textarea>
                    </div>

                    <div className="flex justify-end space-x-3">
                      <button
                        type="button"
                        onClick={() => setIsContactModalOpen(false)}
                        className={`px-4 py-2 rounded-md ${
                          isDarkMode
                            ? "bg-gray-700 hover:bg-gray-600"
                            : "bg-gray-200 hover:bg-gray-300"
                        } !rounded-button whitespace-nowrap`}
                      >
                        Annuler
                      </button>
                      <button
                        type="submit"
                        className={`px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white !rounded-button whitespace-nowrap`}
                      >
                        Envoyer
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {/* Notification */}
            {showNotification && (
              <div className="fixed bottom-4 right-4 z-50">
                <div
                  className={`px-4 py-3 rounded-lg shadow-lg ${
                    isDarkMode ? "bg-green-900" : "bg-green-100"
                  } border ${
                    isDarkMode ? "border-green-800" : "border-green-200"
                  }`}
                >
                  <div className="flex items-center">
                    <i className="fas fa-check-circle text-green-500 mr-2"></i>
                    <p
                      className={`${
                        isDarkMode ? "text-green-100" : "text-green-800"
                      }`}
                    >
                      {notificationMessage}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Tabs Navigation */}
      <div
        className={`px-6 border-b ${
          isDarkMode ? "border-gray-700" : "border-gray-200"
        }`}
      >
        <div className="flex space-x-1">
          <button
            onClick={() => setActiveTab("informations")}
            className={`px-4 py-3 font-medium text-sm border-b-2 ${
              activeTab === "informations"
                ? `${
                    isDarkMode
                      ? "border-blue-500 text-blue-500"
                      : "border-blue-600 text-blue-600"
                  }`
                : `border-transparent ${
                    isDarkMode ? "hover:text-gray-300" : "hover:text-gray-700"
                  }`
            } !rounded-button whitespace-nowrap cursor-pointer`}
          >
            <i className="fas fa-user mr-2"></i>
            Informations personnelles
          </button>
          <button
            onClick={() => setActiveTab("parents")}
            className={`px-4 py-3 font-medium text-sm border-b-2 ${
              activeTab === "parents"
                ? `${
                    isDarkMode
                      ? "border-blue-500 text-blue-500"
                      : "border-blue-600 text-blue-600"
                  }`
                : `border-transparent ${
                    isDarkMode ? "hover:text-gray-300" : "hover:text-gray-700"
                  }`
            } !rounded-button whitespace-nowrap cursor-pointer`}
          >
            <i className="fas fa-users mr-2"></i>
            Parents
          </button>

          <button
            onClick={() => setActiveTab("absences")}
            className={`px-4 py-3 font-medium text-sm border-b-2 ${
              activeTab === "absences"
                ? `${
                    isDarkMode
                      ? "border-blue-500 text-blue-500"
                      : "border-blue-600 text-blue-600"
                  }`
                : `border-transparent ${
                    isDarkMode ? "hover:text-gray-300" : "hover:text-gray-700"
                  }`
            } !rounded-button whitespace-nowrap cursor-pointer`}
          >
            <i className="fas fa-calendar-times mr-2"></i>
            Absences
          </button>
          <button
            onClick={() => setActiveTab("paiements")}
            className={`px-4 py-3 font-medium text-sm border-b-2 ${
              activeTab === "paiements"
                ? `${
                    isDarkMode
                      ? "border-blue-500 text-blue-500"
                      : "border-blue-600 text-blue-600"
                  }`
                : `border-transparent ${
                    isDarkMode ? "hover:text-gray-300" : "hover:text-gray-700"
                  }`
            } !rounded-button whitespace-nowrap cursor-pointer`}
          >
            <i className="fas fa-money-bill-wave mr-2"></i>
            Paiements
          </button>
        </div>
      </div>
      {/* Tab Content */}
      <div className="p-6">
        {/* Informations personnelles */}
        {activeTab === "informations" && (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div
              className={`col-span-2 rounded-lg border ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } overflow-hidden`}
            >
              <div
                className={`px-4 py-3 ${
                  isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
                } border-b ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                }`}
              >
                <h3 className="font-medium">Informations générales</h3>
              </div>
              <div className="p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <div className="mb-4">
                      <p
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-500"
                        } mb-1`}
                      >
                        Nom complet
                      </p>
                      <p className="font-medium">
                        {dataStudent?.nom} {dataStudent?.postnom}{" "}
                        {dataStudent?.prenom}
                      </p>
                    </div>
                    <div className="mb-4">
                      <p
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-500"
                        } mb-1`}
                      >
                        Date de naissance
                      </p>
                      <p className="font-medium">
                        {moment(dataStudent?.date_naissance).format(
                          "DD/MM/YYYY"
                        )}{" "}
                        -
                        {moment().diff(
                          moment(dataStudent?.date_naissance, "YYYY-MM-DD"),
                          "years"
                        )}{" "}
                        {"ans"}
                      </p>
                    </div>
                    <div className="mb-4">
                      <p
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-500"
                        } mb-1`}
                      >
                        Genre
                      </p>
                      <p className="font-medium">
                        {dataStudent?.sexe === "M" ? "Masculin" : "Feminin"}
                      </p>
                    </div>
                    <div className="mb-4">
                      <p
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-500"
                        } mb-1`}
                      >
                        Adresse
                      </p>
                      <p className="font-medium">
                        {capitalizeFirstLetter(dataStudent?.ville)} {", "}{" "}
                        {capitalizeFirstLetter(dataStudent?.quartier)}
                        {", "}
                        {capitalizeFirstLetter(dataStudent?.avenue)}
                      </p>
                    </div>
                  </div>
                  <div>
                    <div className="mb-4">
                      <p
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-500"
                        } mb-1`}
                      >
                        Contact
                      </p>
                      <p className="font-medium">{dataStudent?.telephone}</p>
                    </div>
                    <div className="mb-4">
                      <p
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-500"
                        } mb-1`}
                      >
                        Email
                      </p>
                      <p className="font-medium">{"----------"}</p>
                    </div>
                    <div className="mb-4">
                      <p
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-500"
                        } mb-1`}
                      >
                        Date d'inscription
                      </p>
                      <p className="font-medium">
                        {moment(dataStudent?.created_at).format("DD/MM/YYYY")}
                      </p>
                    </div>
                    <div className="mb-4">
                      <p
                        className={`text-sm ${
                          isDarkMode ? "text-gray-400" : "text-gray-500"
                        } mb-1`}
                      >
                        Classe actuelle
                      </p>
                      <p className="font-medium">
                        {dataStudent?.classeDesignation
                          ? dataStudent?.classeDesignation
                          : "----------"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`rounded-lg border ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } overflow-hidden`}
            >
              <div
                className={`px-4 py-3 ${
                  isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
                } border-b ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                }`}
              >
                <h3 className="font-medium">Informations médicales</h3>
              </div>
              <div className="p-4">
                <div className="mb-4">
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-500"
                    } mb-1`}
                  >
                    Allergies
                  </p>
                  <p className="font-medium">{"-----"}</p>
                </div>
                <div className="mb-4">
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-500"
                    } mb-1`}
                  >
                    Médicaments
                  </p>
                  <p className="font-medium">{"-----"}</p>
                </div>
                <div className="mb-4">
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-500"
                    } mb-1`}
                  >
                    Groupe sanguin
                  </p>
                  <p className="font-medium">{"-----"}</p>
                </div>
                <div className="mb-4">
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-500"
                    } mb-1`}
                  >
                    Médecin traitant
                  </p>
                  <p className="font-medium">{"-----"}</p>
                </div>
                <div className="mb-4">
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-500"
                    } mb-1`}
                  >
                    Téléphone du médecin
                  </p>
                  <p className="font-medium">{"-----"}</p>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Parents */}
        {activeTab === "parents" && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div
              className={`rounded-lg border ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } overflow-hidden`}
            >
              <div
                className={`px-4 py-3 ${
                  isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
                } border-b ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                } flex justify-between items-center`}
              >
                <h3 className="font-medium">Informations générales</h3>
                <div className="flex space-x-2">
                  <button
                    id={`contactParentBtn-${1}`}
                    onClick={() => {
                      // setContactForm({
                      //   recipients: [parent.email],
                      //    subject: "",
                      //    message: "",
                      //    attachments: null,
                      //   parentEmail: parent.email,
                      // });
                      setIsContactModalOpen(true);
                    }}
                    className={`p-2 rounded-full ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-200"
                    } text-blue-500 !rounded-button whitespace-nowrap cursor-pointer`}
                  >
                    <i className="fas fa-envelope"></i>
                  </button>
                </div>
              </div>
              <div className="p-4">
                <div className="mb-4">
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-500"
                    } mb-1`}
                  >
                    Noms
                  </p>
                  <p className="font-medium">
                    {" "}
                    {dataStudent.parentData?.nom ||
                    dataStudent.parentData?.postnom ||
                    dataStudent.parentData?.prenom
                      ? `${dataStudent.parentData?.nom} ${capitalizeFirstLetter(
                          dataStudent.parentData?.prenom
                        )}`
                      : "----------------"}
                  </p>
                </div>
                <div className="mb-4">
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-500"
                    } mb-1`}
                  >
                    Téléphone
                  </p>
                  <p className="font-medium">
                    {dataStudent.parentData.telephone}
                  </p>
                </div>
                <div className="mb-4">
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-500"
                    } mb-1`}
                  >
                    Email
                  </p>
                  <p className="font-medium">{"-----------"}</p>
                </div>
                <div className="mb-4">
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-500"
                    } mb-1`}
                  >
                    Parenté
                  </p>
                  <p className="font-medium">{"---------------"}</p>
                </div>
              </div>
            </div>
            <div
              className={`rounded-lg border ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } overflow-hidden`}
            >
              <div
                className={`px-4 py-3 ${
                  isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
                } border-b ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                } flex justify-between items-center`}
              >
                <h3 className="font-medium">Informations supplémentaires</h3>
              </div>
              <div className="p-4">
                <div className="mb-4">
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-500"
                    } mb-1`}
                  >
                    Profession
                  </p>
                  <p className="font-medium">{"----------------"}</p>
                </div>
                <div className="mb-4">
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-500"
                    } mb-1`}
                  >
                    Ville
                  </p>
                  <p className="font-medium">
                    {capitalizeFirstLetter(dataStudent.parentData.ville)}
                  </p>
                </div>
                <div className="mb-4">
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-500"
                    } mb-1`}
                  >
                    Quartier
                  </p>
                  <p className="font-medium">
                    {" "}
                    {capitalizeFirstLetter(dataStudent.parentData.quartier)}
                  </p>
                </div>
                <div className="mb-4">
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-500"
                    } mb-1`}
                  >
                    Avenue
                  </p>
                  <p className="font-medium">
                    {capitalizeFirstLetter(dataStudent.parentData.avenue)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Absences */}
        {activeTab === "absences" && (
          <div>
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-6">
              <div
                className={`rounded-lg border ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                } overflow-hidden p-4 flex flex-col items-center`}
              >
                <div
                  className={`w-12 h-12 rounded-full flex items-center justify-center ${
                    isDarkMode ? "bg-blue-900" : "bg-blue-100"
                  } text-blue-500 mb-3`}
                >
                  <i className="fas fa-calendar-check"></i>
                </div>
                <p
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-500"
                  } mb-1`}
                >
                  Jours de présence
                </p>
                <p className="text-2xl font-bold">{presenceArr?.length || 0}</p>
              </div>
              <div
                className={`rounded-lg border ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                } overflow-hidden p-4 flex flex-col items-center`}
              >
                <div
                  className={`w-12 h-12 rounded-full flex items-center justify-center ${
                    isDarkMode ? "bg-red-900" : "bg-red-100"
                  } text-red-500 mb-3`}
                >
                  <i className="fas fa-calendar-times"></i>
                </div>
                <p
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-500"
                  } mb-1`}
                >
                  Jours d'absence
                </p>
                <p className="text-2xl font-bold">{absenceArr?.length || 0}</p>
              </div>
              <div
                className={`rounded-lg border ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                } overflow-hidden p-4 flex flex-col items-center`}
              >
                <div
                  className={`w-12 h-12 rounded-full flex items-center justify-center ${
                    isDarkMode ? "bg-yellow-900" : "bg-yellow-100"
                  } text-yellow-500 mb-3`}
                >
                  <i className="fas fa-clock"></i>
                </div>
                <p
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-500"
                  } mb-1`}
                >
                  Jours de retard
                </p>
                <p className="text-2xl font-bold">{retardArr?.length || 0}</p>
              </div>
              <div
                className={`rounded-lg border ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                } overflow-hidden p-4 flex flex-col items-center`}
              >
                <div
                  className={`w-12 h-12 rounded-full flex items-center justify-center ${
                    isDarkMode ? "bg-green-900" : "bg-green-100"
                  } text-green-500 mb-3`}
                >
                  <i className="fas fa-check-circle"></i>
                </div>
                <p
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-500"
                  } mb-1`}
                >
                  Taux de présence
                </p>
                <p className="text-2xl font-bold">{presenceRate}%</p>
              </div>
            </div>
            <div
              className={`rounded-lg border mb-12 ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } overflow-hidden`}
            >
              <div
                className={`px-4 py-3 ${
                  isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
                } border-b ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                } flex justify-between items-center`}
              >
                <h3 className="font-medium">
                  Historique des retards et absences
                </h3>
                {/* <div className="flex space-x-2"> */}
                <div className="relative">
                  <button
                    onClick={toggleStatusDropdown}
                    className={`flex items-center px-4 py-2 rounded-md ${
                      isDarkMode
                        ? "bg-[#161B22] hover:bg-gray-700"
                        : "bg-white hover:bg-gray-100"
                    } border ${
                      isDarkMode ? "border-gray-700" : "border-gray-300"
                    } !rounded-button whitespace-nowrap`}
                  >
                    <i className="fas fa-filter mr-1"></i>

                    <span>
                      {selectedStatusAttendance === 2
                        ? "Retard"
                        : selectedStatusAttendance === 3
                        ? "Absent"
                        : "Tous les statuts"}
                    </span>
                  </button>
                  {isStatusDropdownOpen && (
                    <div
                      className={`absolute z-50 top-full right-0 mt-1 w-48 rounded-md shadow-lg ${
                        isDarkMode ? "bg-[#161B22]" : "bg-white"
                      } z-10 border ${
                        isDarkMode ? "border-gray-700" : "border-gray-300"
                      }`}
                    >
                      <div className="py-1">
                        <button
                          onClick={() => {
                            setSelectedStatusAttendance("Tous les statuts");
                            setIsStatusDropdownOpen(false);
                          }}
                          className={`block px-4 py-2 text-sm w-full text-left ${
                            isDarkMode
                              ? "hover:bg-gray-700"
                              : "hover:bg-gray-100"
                          } !rounded-button whitespace-nowrap`}
                        >
                          Tous les statuts
                        </button>
                        <button
                          onClick={() => {
                            setSelectedStatusAttendance(2);
                            setIsStatusDropdownOpen(false);
                          }}
                          className={`block px-4 py-2 text-sm w-full text-left ${
                            isDarkMode
                              ? "hover:bg-gray-700"
                              : "hover:bg-gray-100"
                          } !rounded-button whitespace-nowrap`}
                        >
                          Retard
                        </button>
                        <button
                          onClick={() => {
                            setSelectedStatusAttendance(3);
                            setIsStatusDropdownOpen(false);
                          }}
                          className={`block px-4 py-2 text-sm w-full text-left ${
                            isDarkMode
                              ? "hover:bg-gray-700"
                              : "hover:bg-gray-100"
                          } !rounded-button whitespace-nowrap`}
                        >
                          Absent
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                {isAbsenceModalOpen && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div
                      className="absolute inset-0 bg-black bg-opacity-50"
                      onClick={() => setIsAbsenceModalOpen(false)}
                    ></div>
                    <div
                      className={`relative w-full max-w-md p-6 rounded-lg shadow-xl ${
                        isDarkMode ? "bg-[#161B22]" : "bg-white"
                      }`}
                    >
                      <h3 className="text-xl font-semibold mb-4">
                        {"Modifier l'absence"}
                      </h3>
                      <div>
                        <div className="mb-4">
                          <label
                            className={`block text-sm font-medium mb-1 ${
                              isDarkMode ? "text-gray-300" : "text-gray-700"
                            }`}
                          >
                            Statut
                          </label>
                          <div className="grid grid-cols-3 gap-2">
                            <button
                              type="button"
                              disabled={mutationUpdateAttendance.isPending}
                              onClick={() => {
                                SetCurrentAttendanceCoteId(1);
                                setAbsenceForm((prev) => ({
                                  ...prev,
                                  status: "present",
                                }));
                              }}
                              className={`p-2 rounded-md flex flex-col items-center ${
                                mutationUpdateAttendance.isPending &&
                                "cursor-not-allowed"
                              }  ${
                                absenceForm.status === "present"
                                  ? "bg-green-600 text-white"
                                  : isDarkMode
                                  ? "bg-gray-700 hover:bg-gray-600"
                                  : "bg-gray-100 hover:bg-gray-200"
                              } !rounded-button whitespace-nowrap`}
                            >
                              <i className="fas fa-check-circle mb-1"></i>
                              <span className="text-sm">Présent</span>
                            </button>
                            <button
                              type="button"
                              disabled={mutationUpdateAttendance.isPending}
                              onClick={() => {
                                SetCurrentAttendanceCoteId(2);
                                setAbsenceForm((prev) => ({
                                  ...prev,
                                  status: "late",
                                }));
                              }}
                              className={`p-2 rounded-md flex flex-col items-center ${
                                mutationUpdateAttendance.isPending &&
                                "cursor-not-allowed"
                              } ${
                                absenceForm.status === "late"
                                  ? "bg-yellow-600 text-white"
                                  : isDarkMode
                                  ? "bg-gray-700 hover:bg-gray-600"
                                  : "bg-gray-100 hover:bg-gray-200"
                              } !rounded-button whitespace-nowrap`}
                            >
                              <i className="fas fa-clock mb-1"></i>
                              <span className="text-sm">En retard</span>
                            </button>
                            <button
                              type="button"
                              disabled={mutationUpdateAttendance.isPending}
                              onClick={() => {
                                SetCurrentAttendanceCoteId(3);
                                setAbsenceForm((prev) => ({
                                  ...prev,
                                  status: "absent",
                                }));
                              }}
                              className={`p-2 rounded-md flex flex-col items-center ${
                                mutationUpdateAttendance.isPending &&
                                "cursor-not-allowed"
                              } ${
                                absenceForm.status === "absent"
                                  ? "bg-red-600 text-white"
                                  : isDarkMode
                                  ? "bg-gray-700 hover:bg-gray-600"
                                  : "bg-gray-100 hover:bg-gray-200"
                              } !rounded-button whitespace-nowrap`}
                            >
                              <i className="fas fa-times-circle mb-1"></i>
                              <span className="text-sm">Absent</span>
                            </button>
                          </div>
                        </div>
                        {(absenceForm.status === "late" ||
                          absenceForm.status === "absent") && (
                          <>
                            <div className="mb-4">
                              <label
                                className={`block text-sm font-medium mb-1 ${
                                  isDarkMode ? "text-gray-300" : "text-gray-700"
                                }`}
                              >
                                Motif de justification
                              </label>

                              <select
                                disabled={mutationUpdateAttendance.isPending}
                                value={absenceForm.reason}
                                onChange={(e) =>
                                  setAbsenceForm((prev) => ({
                                    ...prev,
                                    reason: e.target.value,
                                  }))
                                }
                                className={`w-full px-3 py-1 rounded-md border ${
                                  isDarkMode
                                    ? "bg-[#0D1117] border-gray-700 text-white"
                                    : "bg-white border-gray-300"
                                } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                required
                              >
                                <option value="">Sélectionner un motif</option>
                                <option value="Maladie">Maladie</option>
                                <option value="Rendez-vous médical">
                                  Rendez-vous médical
                                </option>
                                <option value="Problème familial">
                                  Problème familial
                                </option>
                                <option value="Transport">
                                  Problème de transport
                                </option>

                                <option value="Autre">Autre</option>
                              </select>

                              {/* <textarea
                                disabled={mutationFn.isPending}
                                value={absenceForm.reason}
                                onChange={(e) =>
                                  setAbsenceForm((prev) => ({
                                    ...prev,
                                    reason: e.target.value,
                                  }))
                                }
                                rows={3}
                                className={`w-full px-3 py-2 rounded-md border ${
                                  mutationFn.isPending && "cursor-not-allowed"
                                } ${
                                  isDarkMode
                                    ? "bg-[#0D1117] border-gray-700 text-white"
                                    : "bg-white border-gray-300"
                                } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                required
                              ></textarea> */}
                            </div>
                            {/* <div className="mb-4">
                              <label className="flex items-center">
                                <input
                                  type="checkbox"
                                  checked={absenceForm.justified}
                                  onChange={(e) =>
                                    setAbsenceForm((prev) => ({
                                      ...prev,
                                      justified: e.target.checked,
                                    }))
                                  }
                                  className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                />
                                <span
                                  className={`ml-2 text-sm ${
                                    isDarkMode
                                      ? "text-gray-300"
                                      : "text-gray-700"
                                  }`}
                                >
                                  {absenceForm.status === "late"
                                    ? "Retard justifié"
                                    : "Absence justifiée"}
                                </span>
                              </label>
                            </div> */}
                          </>
                        )}
                        <div className="flex justify-end space-x-3">
                          <button
                            type="button"
                            disabled={mutationUpdateAttendance.isPending}
                            onClick={() => {
                              setIsAbsenceModalOpen(false);
                              SetCurrentAttendanceCoteId(null);
                              SetCurrentAttendanceId(null);
                              setAbsenceForm((prev) => ({
                                ...prev,
                                isEditing: false,
                              }));
                            }}
                            className={`px-4 py-2 rounded-md ${
                              mutationUpdateAttendance.isPending &&
                              "cursor-not-allowed"
                            } ${
                              isDarkMode
                                ? "bg-gray-700 hover:bg-gray-600"
                                : "bg-gray-200 hover:bg-gray-300"
                            } !rounded-button whitespace-nowrap`}
                          >
                            Annuler
                          </button>
                          <button
                            disabled={mutationUpdateAttendance.isPending}
                            onClick={() => {
                              handleUpdateAttendance();
                            }}
                            className={`px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white !rounded-button whitespace-nowrap`}
                          >
                            {mutationUpdateAttendance.isPending
                              ? "Chargement..."
                              : "Mettre à jour"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-700">
                  <thead
                    className={`${isDarkMode ? "bg-[#161B22]" : "bg-gray-50"}`}
                  >
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                      >
                        Date
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                      >
                        Cotation
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                      >
                        Justification
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                      >
                        Statut
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    className={`${
                      isDarkMode ? "bg-[#0D1117]" : "bg-white"
                    } divide-y ${
                      isDarkMode ? "divide-gray-700" : "divide-gray-200"
                    }`}
                  >
                    {filteredAttendanceList?.map((item, index) => {
                      let date, cote, motif, justifie, status;
                      date = moment(item.created_at).format("DD/MM/YYYY");
                      cote = item.cote_eleve_id;
                      status = item.cote_eleve_id === 2 ? "late" : "absent";
                      justifie = item.justification ? true : false;
                      motif = item.justification ? item.justification : null;

                      return (
                        <tr
                          key={index}
                          className={`${
                            isDarkMode
                              ? "hover:bg-gray-800"
                              : "hover:bg-gray-50"
                          }`}
                        >
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div
                              className={`font-medium ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              {date}
                            </div>
                          </td>
                          <td className="px-6 py-4 text-left whitespace-nowrap">
                            <div className="flex justify-center space-x-2">
                              <button
                                className={`p-2 rounded-full ${
                                  cote === 3
                                    ? "bg-red-500 text-white"
                                    : isDarkMode
                                    ? "bg-gray-700 text-gray-300"
                                    : "bg-gray-200 text-gray-600"
                                } !rounded-button whitespace-nowrap cursor-pointer`}
                                title="Absent"
                              >
                                <i className="fas fa-times"></i>
                              </button>
                              <button
                                className={`p-2 rounded-full ${
                                  cote === 2
                                    ? "bg-yellow-500 text-white"
                                    : isDarkMode
                                    ? "bg-gray-700 text-gray-300"
                                    : "bg-gray-200 text-gray-600"
                                } !rounded-button whitespace-nowrap cursor-pointer`}
                                title="En retard"
                              >
                                <i className="fas fa-clock"></i>
                              </button>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex justify-center space-x-2">
                              {motif ? item.justification : <span>-</span>}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-center">
                            <span
                              className={`px-2 py-1 text-xs font-semibold rounded-full ${
                                justifie
                                  ? "bg-green-100 text-green-800"
                                  : "bg-red-100 text-red-800"
                              }`}
                            >
                              {justifie ? "Justifiée" : "Non justifiée"}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-center">
                            <div className="flex justify-center space-x-3">
                              <button
                                onClick={() => {
                                  SetCurrentAttendanceId(item.id);
                                  SetCurrentAttendanceCoteId(
                                    item.cote_eleve_id
                                  );
                                  setAbsenceForm({
                                    date: date,
                                    reason: motif,
                                    justified: justifie,
                                    status: status,
                                    isEditing: true,
                                    editingId: index,
                                  });
                                  setIsAbsenceModalOpen(true);
                                }}
                                className="text-green-500 hover:text-green-700 cursor-pointer !rounded-button whitespace-nowrap"
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                              <button className="text-red-300 cursor-not-allowed !rounded-button whitespace-nowrap">
                                <i className="fas fa-trash-alt"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {/* Paiements */}
        {activeTab === "paiements" && (
          <div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
              <div
                className={`rounded-lg border ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                } overflow-hidden p-4`}
              >
                <div className="flex items-center mb-3">
                  <div
                    className={`w-10 h-10 rounded-full flex items-center justify-center ${
                      isDarkMode ? "bg-green-900" : "bg-green-100"
                    } text-green-500`}
                  >
                    <i className="fas fa-money-bill-wave"></i>
                  </div>
                  <div className="ml-3">
                    <p
                      className={`text-sm ${
                        isDarkMode ? "text-gray-400" : "text-gray-500"
                      }`}
                    >
                      Total payé
                    </p>
                    <p className="text-xl font-bold">
                      {" "}
                      {`${getPaymentAmount().paid.toFixed(2)}` || 0} $
                    </p>
                  </div>
                </div>
                <div
                  className={`h-2 w-full rounded-full ${
                    isDarkMode ? "bg-gray-700" : "bg-gray-200"
                  }`}
                >
                  <div
                    className="h-2 rounded-full bg-green-500"
                    style={{
                      width: `${
                        (getPaymentAmount().paid * 100) /
                        getPaymentAmount().total
                      }%`,
                    }}
                  ></div>
                </div>
                <div className="flex justify-between mt-2 text-sm">
                  <span
                    className={`${
                      isDarkMode ? "text-gray-400" : "text-gray-500"
                    }`}
                  >
                    Progression
                  </span>
                  <span className="font-medium">
                    {getPaymentAmount().percentage}%
                  </span>
                </div>
              </div>
              <div
                className={`rounded-lg border ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                } overflow-hidden p-4`}
              >
                <div className="flex items-center mb-3">
                  <div
                    className={`w-10 h-10 rounded-full flex items-center justify-center ${
                      isDarkMode ? "bg-yellow-900" : "bg-yellow-100"
                    } text-yellow-500`}
                  >
                    <i className="fas fa-clock"></i>
                  </div>
                  <div className="ml-3">
                    <p
                      className={`text-sm ${
                        isDarkMode ? "text-gray-400" : "text-gray-500"
                      }`}
                    >
                      En attente
                    </p>
                    <p className="text-xl font-bold">
                      {" "}
                      {`${getPaymentAmount().balance.toFixed(2)}` || 0} $
                    </p>
                  </div>
                </div>
                <div
                  className={`p-2 rounded-md ${
                    isDarkMode ? "bg-yellow-900 bg-opacity-20" : "bg-yellow-50"
                  } border ${
                    isDarkMode ? "border-yellow-800" : "border-yellow-100"
                  } text-sm`}
                >
                  <i className="fas fa-exclamation-triangle text-yellow-500 mr-1"></i>
                  {filteredPaiementsForStudent[0]
                    ? `Dernier paiement -  ${moment(
                        filteredPaiementsForStudent[0].created_at
                      ).format("DD/MM/YYYY")}`
                    : "Aucun paiement"}
                </div>
              </div>
              <div
                className={`rounded-lg border ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                } overflow-hidden p-4`}
              >
                <div className="flex items-center mb-3">
                  <div
                    className={`w-10 h-10 rounded-full flex items-center justify-center ${
                      isDarkMode ? "bg-blue-900" : "bg-blue-100"
                    } text-blue-500`}
                  >
                    <i className="fas fa-calculator"></i>
                  </div>
                  <div className="ml-3">
                    <p
                      className={`text-sm ${
                        isDarkMode ? "text-gray-400" : "text-gray-500"
                      }`}
                    >
                      Total annuel
                    </p>
                    <p className="text-xl font-bold">
                      {`${getPaymentAmount().total.toFixed(2)}` || 0} $
                    </p>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <div>
                    <p
                      className={`text-sm ${
                        isDarkMode ? "text-gray-400" : "text-gray-500"
                      }`}
                    >
                      Frais de scolarité
                    </p>
                    <p className="font-medium">
                      {" "}
                      {`${getPaymentAmount().total.toFixed(2)}` || 0} $
                    </p>
                  </div>
                  <div>
                    <p
                      className={`text-sm ${
                        isDarkMode ? "text-gray-400" : "text-gray-500"
                      }`}
                    >
                      Frais annexes
                    </p>
                    <p className="font-medium">$00</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`rounded-lg border mb-12 ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } overflow-hidden`}
            >
              <div
                className={`px-4 py-3 ${
                  isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
                } border-b ${
                  isDarkMode ? "border-gray-700" : "border-gray-200"
                } flex justify-between items-center`}
              >
                <h3 className="font-medium">Historique des paiements</h3>
                <div className="flex space-x-2">
                  <button
                    id="newPaymentBtn"
                    onClick={() => {
                      setPaymentForm({
                        date: "",
                        amount: "",
                        type: paymentForm.type,
                        method: "Espèce",
                        status: paymentForm.status,
                        isEditing: false,
                        editingId: null,
                      });
                      setIsPaymentModalOpen(true);
                    }}
                    className={`px-3 py-1 rounded-md text-sm ${
                      isDarkMode
                        ? "bg-blue-600 hover:bg-blue-700"
                        : "bg-blue-500 hover:bg-blue-600"
                    } text-white !rounded-button whitespace-nowrap`}
                  >
                    <i className="fas fa-plus mr-1"></i>
                    Nouveau paiement
                  </button>
                  {isPaymentModalOpen && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center">
                      <div
                        className="absolute inset-0 bg-black bg-opacity-50"
                        onClick={() => setIsPaymentModalOpen(false)}
                      ></div>
                      <div
                        className={`relative w-full max-w-md p-6 rounded-lg shadow-xl ${
                          isDarkMode ? "bg-[#161B22]" : "bg-white"
                        }`}
                      >
                        <h3 className="text-xl font-semibold mb-4">
                          {paymentForm.isEditing
                            ? "Modifier le paiement"
                            : "Nouveau paiement"}
                        </h3>
                        <div>
                          <div className="mb-4">
                            <label
                              className={`block text-sm font-medium mb-1 ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              Montant ($)
                            </label>
                            <input
                              type="number"
                              value={paymentForm.amount}
                              onChange={(e) =>
                                setPaymentForm((prev) => ({
                                  ...prev,
                                  amount: Number(e.target.value),
                                }))
                              }
                              className={`w-full px-3 py-2 rounded-md border ${
                                isDarkMode
                                  ? "bg-[#0D1117] border-gray-700 text-white"
                                  : "bg-white border-gray-300"
                              } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                              required
                              min="0"
                              step="0.01"
                            />
                          </div>
                          <div className="mb-4">
                            <label
                              className={`block text-sm font-medium mb-1 ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              Type de frais
                            </label>
                            <select
                              value={paymentForm.type}
                              onChange={(e) =>
                                setPaymentForm((prev) => ({
                                  ...prev,
                                  type: e.target.value,
                                }))
                              }
                              className={`w-full px-3 py-1 rounded-md border ${
                                isDarkMode
                                  ? "bg-[#0D1117] border-gray-700 text-white"
                                  : "bg-white border-gray-300"
                              } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                              required
                            >
                              <option value={1} defaultChecked>
                                Frais de scolarité
                              </option>
                            </select>
                          </div>
                          <div className="mb-4">
                            <label
                              className={`block text-sm font-medium mb-1 ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              Mode de paiement
                            </label>
                            <select
                              value={paymentForm.method}
                              onChange={(e) =>
                                setPaymentForm((prev) => ({
                                  ...prev,
                                  method: e.target.value,
                                }))
                              }
                              className={`w-full px-3 py-1 rounded-md border ${
                                isDarkMode
                                  ? "bg-[#0D1117] border-gray-700 text-white"
                                  : "bg-white border-gray-300"
                              } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                              required
                            >
                              <option value="Espèces">Espèce</option>
                            </select>
                          </div>
                          <div className="mb-4">
                            <label
                              className={`block text-sm font-medium mb-1 ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              Statut
                            </label>
                            <select
                              value={paymentForm.status}
                              onChange={(e) =>
                                setPaymentForm((prev) => ({
                                  ...prev,
                                  status: e.target.value,
                                }))
                              }
                              className={`w-full px-3 py-1 rounded-md border ${
                                isDarkMode
                                  ? "bg-[#0D1117] border-gray-700 text-white"
                                  : "bg-white border-gray-300"
                              } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                              required
                            >
                              <option value={1}>Payé</option>
                              {/* {paymentForm.isEditing && (
                                <option value={0}>Annulé</option>
                              )} */}
                            </select>
                          </div>
                          <div className="flex justify-end space-x-3">
                            <button
                              type="button"
                              disabled={
                                mutationCreatePayment.isPending ||
                                mutationUpdatePayment.isPending
                              }
                              onClick={() => setIsPaymentModalOpen(false)}
                              className={`px-4 py-2 rounded-md ${
                                isDarkMode
                                  ? "bg-gray-700 hover:bg-gray-600"
                                  : "bg-gray-200 hover:bg-gray-300"
                              } !rounded-button whitespace-nowrap  ${
                                (mutationCreatePayment.isPending ||
                                  mutationUpdatePayment.isPending) &&
                                "cursor-not-allowed"
                              }`}
                            >
                              Annuler
                            </button>
                            <button
                              onClick={handleSubmitPayement}
                              disabled={
                                mutationCreatePayment.isPending ||
                                mutationUpdatePayment.isPending
                              }
                              className={`px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white !rounded-button whitespace-nowrap ${
                                (mutationCreatePayment.isPending ||
                                  mutationUpdatePayment.isPending) &&
                                "cursor-not-allowed"
                              }`}
                            >
                              {mutationCreatePayment.isPending ||
                              mutationUpdatePayment.isPending
                                ? "Chargement..."
                                : paymentForm.isEditing
                                ? "Mettre à jour"
                                : "Enregistrer"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-700">
                  <thead
                    className={`${isDarkMode ? "bg-[#161B22]" : "bg-gray-50"}`}
                  >
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                      >
                        Date
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                      >
                        Montant
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                      >
                        Type
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                      >
                        Statut
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    className={`${
                      isDarkMode ? "bg-[#0D1117]" : "bg-white"
                    } divide-y ${
                      isDarkMode ? "divide-gray-700" : "divide-gray-200"
                    }`}
                  >
                    {filteredPaiementsForStudent.map((paiement, index) => {
                      let motif: string = "",
                        motifId: any;

                      for (let element of motifPaiementArr) {
                        if (paiement.motif_paiement_id === element.id) {
                          motif = element.designation;
                          motifId = element.id;
                        }
                      }

                      return (
                        <tr
                          key={index}
                          className={`${
                            isDarkMode
                              ? "hover:bg-gray-800"
                              : "hover:bg-gray-50"
                          }`}
                        >
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div
                              className={`font-medium ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              {moment(paiement.created_at).format("DD/MM/YYYY")}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap font-medium">
                            {paiement.montant} $
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            {motif}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-center">
                            <span
                              className={`px-2 py-1 text-xs font-semibold rounded-full ${
                                paiement.status === 1
                                  ? "bg-green-100 text-green-800"
                                  : paiement.status === 0
                                  ? "bg-red-100 text-red-800"
                                  : "bg-yellow-100 text-yellow-800"
                              }`}
                            >
                              {paiement.status === 1 ? "Payé" : "Annulé"}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-center">
                            <div className="flex justify-center space-x-3">
                              <button
                                id={`receiptBtn-${index}`}
                                onClick={() => {
                                  const receiptData = {
                                    id: `INV-${new Date().getFullYear()}-${String(
                                      index + 1
                                    ).padStart(4, "0")}`,
                                    date: paiement.created_at,
                                    amount: paiement.montant,
                                    type: motifId,
                                    method: "Espèce",
                                    status: paiement.status,
                                    student: dataStudent.nom,
                                    class: dataStudent.classeDesignation,
                                  };
                                  setReceiptData(receiptData);
                                  setIsReceiptModalOpen(true);
                                }}
                                className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap"
                              >
                                <i className="fas fa-receipt"></i>
                              </button>
                              <button
                                disabled={!paiement.status}
                                onClick={() => {
                                  setCurrentPaiementId(paiement.id);
                                  setPaymentForm({
                                    date: paiement.created_at
                                      .split("/")
                                      .reverse()
                                      .join("-"), // Convert DD/MM/YYYY to YYYY-MM-DD
                                    amount: paiement.montant,
                                    type: motifId,
                                    method: "Espèce", // Default value since it's not in the original data
                                    status: paiement.status,
                                    isEditing: true,
                                    editingId: index,
                                  });
                                  setIsPaymentModalOpen(true);
                                }}
                                className={`${
                                  !paiement.status
                                    ? "cursor-not-allowed text-gray-400"
                                    : "cursor-pointer text-green-500 hover:text-green-700"
                                } !rounded-button whitespace-nowrap`}
                                title="Modifier"
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                              <button
                                disabled={!paiement.status}
                                onClick={() => {
                                  setCurrentPaiementId(paiement.id);
                                  setIsAnnulerPaymentModalOpen(true);
                                  setPaymentForm((prev) => ({
                                    ...prev,
                                    amount: paiement.montant,
                                  }));
                                }}
                                className={`${
                                  !paiement.status
                                    ? "text-gray-400 cursor-not-allowed"
                                    : "text-red-500 hover:text-red-700 cursor-pointer"
                                }  !rounded-button whitespace-nowrap`}
                                title="Annuler"
                              >
                                <i className="fas fa-trash-alt"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Receipt Modal */}
      {isReceiptModalOpen && receiptData && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => setIsReceiptModalOpen(false)}
          ></div>
          <div
            className={`relative w-full max-w-2xl p-8 rounded-lg shadow-xl ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            }`}
          >
            <div className="flex justify-between items-start mb-6">
              <div>
                <h2 className="text-2xl font-bold mb-1">Détail de paiement</h2>
                {/* <p
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  15 Rue de l'Education
                  <br />
                  75001 Paris, France
                  <br />
                  Tel: +33 1 23 45 67 89
                  <br />
                  Email: contact@edugest.fr
                </p> */}
              </div>
              <div className="text-right">
                {/* <h3 className="text-xl font-semibold mb-1">REÇU DE PAIEMENT</h3> */}
                <p
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  Date: {moment(receiptData.date).format("DD/MM/YYYY HH:MM")}
                </p>
              </div>
            </div>
            <div
              className={`p-6 rounded-lg mb-6 ${
                isDarkMode ? "bg-[#0D1117]" : "bg-gray-100"
              }`}
            >
              <h4 className="font-semibold mb-3">Informations de l'élève</h4>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Noms de l'élève
                  </p>
                  <p className="font-medium">
                    {`${capitalizeFirstLetter(
                      dataStudent.nom
                    )} ${capitalizeFirstLetter(
                      dataStudent.postnom
                    )} ${capitalizeFirstLetter(dataStudent.prenom)}`}
                  </p>
                </div>
                <div>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Classe
                  </p>
                  <p className="font-medium">{dataStudent.classeDesignation}</p>
                </div>
              </div>
            </div>
            <div
              className={`mb-6 ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              }`}
            >
              <table className="w-full">
                <thead>
                  <tr
                    className={`${isDarkMode ? "bg-[#0D1117]" : "bg-gray-50"}`}
                  >
                    <th className="px-4 py-2 text-left">Description</th>
                    <th className="px-4 py-2 text-right">Montant</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    className={`${
                      isDarkMode ? "border-gray-700" : "border-gray-200"
                    } border-t`}
                  >
                    <td className={` px-4 py-3`}>
                      <span
                        className={`${
                          isDarkMode ? "text-gray-200" : "text-gray-500"
                        }`}
                      >
                        {receiptData.type}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-right font-medium">
                      {receiptData.amount}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr
                    className={`${
                      isDarkMode
                        ? "border-gray-700 bg-[#0D1117]"
                        : "border-gray-200 bg-gray-50"
                    } border-t`}
                  >
                    <td
                      className={`px-4 py-3 font-semibold ${
                        isDarkMode
                          ? "border-gray-700  bg-[#0D1117]"
                          : "border-gray-200 bg-gray-50"
                      }`}
                    >
                      <span
                        className={`${
                          isDarkMode ? "text-gray-200" : "text-gray-500"
                        }`}
                      >
                        Total
                      </span>
                    </td>
                    <td
                      className={`px-4 py-3 font-semibold text-right ${
                        isDarkMode
                          ? "border-gray-700 bg-[#0D1117]"
                          : "border-gray-200 bg-gray-50"
                      }`}
                    >
                      {receiptData.amount}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div
              className={`p-4 rounded-lg mb-6 ${
                isDarkMode ? "bg-[#0D1117]" : "bg-gray-100"
              }`}
            >
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Mode de paiement
                  </p>
                  <p className="font-medium">{"Espèce"}</p>
                </div>
                <div>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Statut
                  </p>
                  <p
                    className={`font-medium ${
                      receiptData.status === 1
                        ? "text-green-500"
                        : receiptData.status === 0
                        ? "text-yellow-500"
                        : "text-red-500"
                    }`}
                  >
                    {receiptData.status === 1 ? "Payé" : "Annulé"}
                  </p>
                </div>
              </div>
            </div>
            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setIsReceiptModalOpen(false)}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-red-700 hover:bg-red-600"
                    : "bg-gray-200 hover:bg-gray-300"
                } !rounded-button whitespace-nowrap`}
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Annuler Paiement Confirmation Modal */}
      {isAnnulerPaymentModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => setIsAnnulerPaymentModalOpen(false)}
          ></div>
          <div
            className={`relative w-full max-w-md p-6 rounded-lg shadow-xl ${
              isDarkMode ? "bg-[#161B22]" : "bg-white"
            }`}
          >
            <div className="flex items-center mb-4">
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center ${
                  isDarkMode ? "bg-red-900" : "bg-red-100"
                } text-red-500 mr-4`}
              >
                <i className="fas fa-exclamation-triangle text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-semibold">
                  Confirmer l'annulation
                </h3>
              </div>
            </div>
            <div
              className={`p-4 rounded-lg mb-4 ${
                isDarkMode ? "bg-[#0D1117]" : "bg-gray-100"
              }`}
            >
              <p
                className={`mb-2 ${
                  isDarkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                Êtes-vous sûr de vouloir annuler ce paiement de{" "}
                <span className="font-semibold">
                  {paymentForm.amount} {" $"}
                </span>{" "}
                ? Cette action est irréversible
              </p>
            </div>
            <div className="flex justify-end space-x-3">
              <button
                disabled={mutationAnnulerPayment.isPending}
                onClick={() => {
                  setCurrentPaiementId(null);
                  setIsAnnulerPaymentModalOpen(false);
                }}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-gray-700 hover:bg-gray-600"
                    : "bg-gray-200 hover:bg-gray-300"
                } !rounded-button whitespace-nowrap ${
                  mutationAnnulerPayment.isPending && "cursor-not-allowed"
                }`}
              >
                Annuler
              </button>
              <button
                disabled={mutationAnnulerPayment.isPending}
                onClick={() => {
                  handleAnnulerPayement();
                }}
                className={`px-4 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white !rounded-button whitespace-nowrap ${
                  mutationAnnulerPayment.isPending && "cursor-not-allowed"
                }`}
              >
                {mutationAnnulerPayment.isPending
                  ? "Chargement..."
                  : "Confirmer l'annulation"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Bottom Action Bar */}
      <div
        className={`fixed bottom-0 left-60 right-0 py-3 px-6 border-t ${
          isDarkMode
            ? "bg-[#0D1117] border-gray-700"
            : "bg-white border-gray-200"
        } flex justify-between items-center`}
      >
        <div>
          <span
            className={`text-sm ${
              isDarkMode ? "text-gray-400" : "text-gray-500"
            }`}
          >
            Date du jour: {moment().format("DD/MM/YYYY")}
          </span>
        </div>
        <div className="flex space-x-3">
          <span
            className={`text-sm ${
              isDarkMode ? "text-gray-400" : "text-gray-500"
            }`}
          >
            ChikSoft v2.0.1
          </span>
        </div>
      </div>
    </div>
  );
};
export default SingleStudent;
